import { useState } from 'react';

/**
 *  @description Хук для поповера
 *
 *  @example
 * const { handleOpen, handleClose, open, anchorEl } = useAnchorElement();
 * return (
    <>
     <Button onClick={handleOpen}>+</Button>
     <Popover
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
        Внутренности поповера
     </Popover>
    </>
 )
 */
export const useAnchorElement = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return { handleClose, handleOpen, open, anchorEl };
};
